import React, { useState } from "react";
import Collapsible from "components/collapsible";
import RichText from "components/rich-text";
import Image from "components/image";
import ButtonLink from "components/button-link";
import clsx from "clsx/lite";

const Accordions = ({ data, className, itemsTitleClass }) => {
	const { title, items } = data;
	const [activeKeys, setActiveKeys] = useState([]);

	const setActiveAccordion = (key) => {
		setActiveKeys((prev) =>
			prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]
		);
	};

	return (
		<div className={clsx("standard-section-width mx-auto", data.settings?.isFluid && "horizontal-padding")}>
			{title &&
				<h3 className={clsx("pb-4",
					data.fontLato && "font-base font-medium text-h2-xs lg:text-5xl",
					data.centerTitle && "text-center")}>
					{title}
				</h3>}
			{items?.map((item) => (
				<Collapsible
					key={item._key}
					label={item.title}
					title={
						<div className="flex gap-3 items-center">
							{item.icon && <Image image={item.icon} className="w-6 h-fit" />}
							<h4 className={clsx("text-start font-base", itemsTitleClass,
								data.smallerFont ? "text-base md:text-2xl font-bold md:font-medium" : "font-semibold")}>
								{item.title}
							</h4>
						</div>
					}
					icon={item.icon}
					isOpen={activeKeys.includes(item._key)}
					setIsOpen={() => setActiveAccordion(item._key)}
					className={clsx("border-b", className,
						data.smallerFont ? "pt-3 md:pt-5 md:pb-2" : "pt-6 pb-3"
					)}
					iconClass="size-6"
					contentClass="text-sm pb-1 md:text-base pr-10"
				>
					<RichText data={item} />
				</Collapsible>
			))}
			<ButtonLink
				data={data?.cta}
				className="text-center flex w-fit mx-auto mt-10 md:py-5"
			/>
		</div>);
};

export default Accordions;